module.exports = __webpack_public_path__ + "skybox.a339cacf64787dfd24cf7b6794f9ff16.png";